import virusBg from "../assets/projects/virusScope/virus_2.png";
import weatherBg from "../assets/projects/weathered_1.png";
// import ateliersBg from "../assets/projects/ateliersza/ateliers_5.png";
import FFbg from "../assets/projects/freshfinds/FF-mock-2.png";
import TASbg from "../assets/projects/TASmart/tas-2.png";
import WWbg from "../assets/projects/workWave/WorkWave-mockups-2.png"
import CFbg from "../assets/projects/chickfileh/cf-2.2.png"

export const homeWorkData = [
	{
		title: "Fresh Finds",
		img: FFbg,
		desc: "An Online Grocery Web Application that allows customers to purchase from stores closest to their location with convenient delivery options.",
		descDetail:
			"Developed An Online Grocery Web Application. Delivered a functional e-commerce web app that allows the customer to shop from the store closest to their location, choose the most convenient shipping method, manage different shipping addresses, get shopping vouchers, and many more.",
		// webLink: "https://jcwd020801.purwadhikabootcamp.com/",
		webLink: "https://my-fresh-finds.vercel.app/",
		githubLink: "https://github.com/thobyza/FreshFinds",
		projectLink: "/project/freshfinds",
		year: 2023,
		role: ["Fullstack Development", "UI Design"],
		techStack: [
			"React,  Node.js,  Express,  Sequelize,  MySQL,  Tailwind,  Figma,  Framer Motion",
		],
		team: ["Vaditto Luthfan,  Hafizh Khairuddin"],
		imgData: [
			"/assets/projects/freshfinds/ff-main.webp",
			"/assets/projects/freshfinds/ff-6.webp",
			"/assets/projects/freshfinds/ff-5.webp",
			"/assets/projects/freshfinds/ff-7.webp",
			"/assets/projects/freshfinds/ff-8.webp",
			"/assets/projects/freshfinds/ff-9.webp",
		],
	},
	{
		title: "Chick-Fil-Eh",
		img: CFbg,
		desc: "An Online Grocery Web Application that allows customers to purchase from stores closest to their location with convenient delivery options.",
		descDetail:
			"Developed a front-end slicing app inspired by the Chick-fil-A menu experience. Recreated a responsive, visually engaging interface where users can browse items, view details, and simulate ordering flows.",
		webLink: "https://chick-fil-eh.netlify.app/",
		githubLink: "https://github.com/thobyza/FE-slicing-practice",
		projectLink: "/project/chickfileh",
		year: 2025,
		role: ["Frontend Development", "UI Design"],
		techStack: ["Next.js,  TypeScript,  Tailwind,  Figma"],
		imgData: [
			"/assets/projects/chickfileh/cf-2.2.png",
			"/assets/projects/chickfileh/cf-1.png",
			"/assets/projects/chickfileh/cf-3.2.png",
			"/assets/projects/chickfileh/cf-4.png",
		],
	},
	{
		title: "TASmart",
		img: TASbg,
		desc: "Point of Sales (POS) Web Application. Streamline transactions, manage inventory, and track sales effortlessly. ",
		descDetail:
			"Developed a Point of Sales (POS) application to help businesses in the Food and Beverage Industry. Successfully implemented an intuitive web system with separate pages for admin and cashier, that helped to streamline transactions, manage inventory, and track sales effortlessly.",
		webLink: "",
		githubLink: "https://github.com/thobyza/Cashier-App",
		projectLink: "/project/tasmart",
		year: 2023,
		role: ["Fullstack Development", "UI Design"],
		techStack:
			"React,  Node.js,  Express,  Sequelize,  MySQL,  Chakra UI,  Figma",
		team: ["Syamsuddin Nur,  M Aman Hidayat"],
		imgData: [
			"/assets/projects/tasmart/tas-5.webp",
			"/assets/projects/tasmart/tas-2.webp",
			"/assets/projects/tasmart/tas-6.webp",
			"/assets/projects/tasmart/tas-8.webp",
			"/assets/projects/tasmart/tas-9.webp",
			"/assets/projects/tasmart/tas-7.webp",
		],
	},
	{
		title: "WorkWave",
		img: WWbg,
		desc: "Job seeking made easy: apply jobs, explore companies, update profiles, and build CVs hassle-free on WorkWave.",
		descDetail:
			"Discover your next career move with ease! Browse job openings, apply instantly, research companies, update your profile, and build a standout CV, all on our intuitive platform designed to streamline your job seeking experience.",
		// webLink: "https://jcwd020801.purwadhikabootcamp.com/",
		// githubLink: "https://github.com/thobyza/FreshFinds",
		projectLink: "/project/workwave",
		year: 2024,
		role: ["Fullstack Development", "UI Design"],
		techStack: [
			"React,  Node.js,  Express,  Sequelize,  MySQL,  Shadcn UI,  Figma,  Framer Motion",
		],
		imgData: ["/assets/projects/workwave/ww-1.webp"],
	},
	{
		title: "WeatherEd",
		img: weatherBg,
		desc: "Simply search any location to access real-time weather data instantly. From temperature to precipitation and wind speed.",
		descDetail:
			"Easily access real-time weather data for any location with our intuitive app. Instantly find temperature, precipitation, and wind speed updates. Stay informed and prepared with accurate information from reliable sources, making planning your day or outdoor activities a breeze.",
		webLink: "https://weather-ed.netlify.app",
		githubLink: "https://github.com/thobyza/WeatherEd",
		projectLink: "/project/weathered",
		year: 2022,
		role: ["Frontend", "UI Design"],
		techStack: ["HTML,  CSS,  Bootstrap"],
		imgData: [
			"/assets/projects/weathered/we-2.webp",
			"/assets/projects/weathered/we-1.webp",
		],
	},
	{
		title: "Virus Scope",
		img: virusBg,
		desc: "COVID-19 dashboard app, Live data tracking on any country. Latest updates on cases, vaccinations, and major developments.",
		descDetail:
			"COVID-19 Dashboard App,  offering live updates on cases, vaccinations, and major developments on any countries - one search away. Keeping people informed with accurate data from trusted sources and informative articles, covering everything from daily case counts to emerging variants.",
		webLink: "https://virusscope.netlify.app",
		githubLink: "https://github.com/thobyza/VirusScope",
		projectLink: "/project/virusscope",
		year: 2022,
		role: ["Frontend", "UI Design"],
		techStack: ["HTML,  CSS,  Materialize CSS"],
		imgData: [
			"/assets/projects/virusscope/virus-2.webp",
			"/assets/projects/virusscope/virus-1.webp",
		],
	},
	// {
	//     title: "Ateliers Z+A",
	//     img: ateliersBg,
	//     desc: "Company Profile website that offers services in digital design, product design, and crafting.",
	//     descDetail: "Company Profile website that offers services in digital design, product design, and crafting.",
	//     webLink: "https://ateliers-za.netlify.app",
	//     githubLink: "https://github.com/thobyza/Ateliers-za",
	//     projectLink: "/project/ateliersza",
	//     year: 2022,
	//     role: ["Frontend"],
	//     techStack: ["HTML,  CSS,  Bootstrap"]
	// },
	// { title: "Other Works", img:  },
];
